import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { PeerOwnershipHoldingsModel } from './peer-ownership-holdings.model';

export class PeerOwnershipHoldingsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'PeerOwnershipHoldingsConfiguration';
  nodataLocalizationKeyName = 'peerOwnershipHoldings';
  readonly reportSection = ReportSection.PeerOwnershipHoldings;
  readonly applicableReportTypes = [ReportType.OwnershipAnalyticsReport];
  readonly reportViewModelSections = [ReportViewModelSection.OwnershipAnalyticsReport_PeerOwnershipHoldings];
  readonly minSize = 2;
  readonly maxSize = 4;
  readonly defaultSize = 2;
  readonly availableDataSections = [];

  get name(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'peerOwnershipHoldings';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'Peer Ownership Holdings';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface PeerOwnershipHoldingsData {
  [ReportViewModelSection.OwnershipAnalyticsReport_PeerOwnershipHoldings]: PeerOwnershipHoldingsModel;
}
